/**
 * Case Form entity
 * Represents a form in the case management system
 */
export class CaseFormEntity {
  public id!: string;
  public name!: string;
  public description!: string;
  public caseTypeId!: string;
  public caseTypeName!: string;
  public status!: 'Draft' | 'Published' | 'Archived';
  public statusName!: string;
  public publishedVersionId!: string | null;
  public publishedVersionNumber!: number | null;
  public fieldCount!: number;
  public createdAt!: Date;
  public updatedAt!: Date;
}
